var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[_c('chart',{attrs:{"height":_vm.height1,"color":_vm.color1,"width":_vm.width1,"path":_vm.path1,"id":_vm.id1,"params":_vm.params1,"lazy":true,"show_mode":_vm.show_mode1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }